import type { HttpPost } from '@/shared/infra/http'
import type { AddChannelMembers } from '@/modules/connect/use-cases'
import { mapChannelAdminError } from './map-channel-admin-error'

type AddChannelMembersResponseDto = {
  added?: string[] | null
}

export class EdgeAddChannelMembersRepository {
  constructor(private readonly http: HttpPost) {}

  execute: AddChannelMembers = async (params) => {
    try {
      const data = await this.http.post<unknown, AddChannelMembersResponseDto>({
        url: `/connect/channels/${encodeURIComponent(params.channelId)}/members`,
        body: {
          orgId: params.orgId,
          orgType: params.orgType,
          memberIds: params.memberIds,
        },
      })
      return { added: data?.added ?? [] }
    } catch (err) {
      throw mapChannelAdminError(err)
    }
  }
}
